// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__28W5J","errorLogs":"EditorFooter_errorLogs__bCkT0"};